import Joi from 'joi';

import Button from '../../themed/button';
import Form from '../../common/form';

import { func, object } from 'prop-types';
import { ETIReportItem } from '../../../utils/models';
import { IMAGE_LIMITS } from '../../../utils/constants';
import { getResultOptions } from '../../../utils/data';

class ETInspectionItemEditForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		srNo: Joi.number().min(0).required().label('SR. No.'),
		description: Joi.string().min(3).required().label('Description'),
		result: Joi.string().required().label('Result'),
		images: Joi.array().min(1).max(IMAGE_LIMITS.GENERAL_PHOTOS).required().label('Images'),
	};

	static propTypes = {
		onEdit: func,
		onCancelEdit: func,
		initialData: object
	};

	componentDidMount() {
		if (this.props.initialData) {
			this.setState({ data: this.props.initialData });
		}
	}

	doSubmit = (): void => {
		this.props.onEdit(this.state.data);
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							name: 'description',
							type: 'text',
							label: 'Description',
							placeholder: 'Enter Description',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'result',
							label: 'Result',
							placeholder: 'Select Result',
							options: getResultOptions(),
						})}
					</div>

					<div className="col">
						{this.renderCreatableMultiselect({
							closeMenuOnSelect: true,
							options: this.props.photoNumbers,
							name: 'images',
							placeholder: 'Select Photo Number',
							label: 'Photo Number',
							isMulti: true,
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="d-flex justify-content-end">
					<div className="mx-3">
						<Button 
							label='Cancel'
							onClick={this.props.onCancelEdit}
							style={{ backgroundColor: 'red' }}
						/>
					</div>

					{this.renderButton('Save Changes')}
				</div>
			</form>
		);
	}
}

const initialData: ETIReportItem = {
	srNo: 0,
	description: '',
	result: '',
	images: [],
};

export default ETInspectionItemEditForm;
